require('./cardTransferMoneyToCheckingAccountView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ actions
const cardTransferMoneyToCheckingAccountActions = require('actions/contactCenter/cardTransferMoneyToCheckingAccount');
const PrinterActions = require('actions/contactCenter/printer');

// @ commons
const { formatText } = require('core/i18n').i18n;
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');

// @ constants
const { FIRST_STEP, WIZARD_VERTICAL_VIEW_MODE } = require('constants/index');
const { COMMISSION_PERCENTAGE, AMOUNT_MULTIPLE_OF_NUMBER, MINIMUM_TO_TRANSFER, MAXIMUM_TO_TRANSFER } = require('constants/contactCenter/cardTransferMoneyToCheckingAccount');
const { CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT } = require('constants/contactCenter/operationTypes');

// @ components
const CustomCardDetails = require('components/contactCenter/customCardDetails/customCardDetails');
const ContractInfo = require('components/contactCenter/contractInfo/contractInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardTransferMoneyToCheckingAccountStep1 = require('components/contactCenter/cardTransferMoneyToCheckingAccount/cardTransferMoneyToCheckingAccountStep1/cardTransferMoneyToCheckingAccountStep1');
const CardTransferMoneyToCheckingAccountFeedbackSuccess = require('components/contactCenter/cardTransferMoneyToCheckingAccount/cardTransferMoneyToCheckingAccountFeedbackSuccess/cardTransferMoneyToCheckingAccountFeedbackSuccess');
const CardTransferMoneyToCheckingAccountFeedbackError = require('components/contactCenter/cardTransferMoneyToCheckingAccount/cardTransferMoneyToCheckingAccountFeedbackError/cardTransferMoneyToCheckingAccountFeedbackError');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');

// @ helpers
const stringHelper = require('utilities/stringHelper');
const { formatCardContract } = require('utilities/cardsHelper');
const { formatAmountForService } = require('utilities/currencyHelper')

class CardTransferMoneyToCheckingAccountView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleToggleCancelModal = this.handleToggleCancelModal.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.state = {
            showModal: false
        };
    }

    componentDidMount() {
        const { match: { params: { cardId } }, requestCardTransferMoneyToCheckingAccount } = this.props;

        requestCardTransferMoneyToCheckingAccount(cardId);
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    handleConfirmLeave() {
        this.props.resetPrintedIndicators();
    }

    handleAmountChange(newAmount) {
        this.props.handleAmountChange(newAmount);
    }

    handleFinish() {
        const { match: { params: { cardId } }, handleFinish } = this.props;

        handleFinish(cardId);
    }

    handleCancel() {
        const { cardId } = this.props.match.params;

        this.props.history.push(`/myprofile/cards/${cardId}/movements`);
    }

    handleToggleCancelModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    buildPreleaveCancelModal() {
        return (
            <PreleaveCancelModal
                isOpen={this.state.showModal}
                onCancel={this.handleCancel}
                onCloseModal={this.handleToggleCancelModal}
                onStayHere={this.handleToggleCancelModal}
            />
        );
    }

    buildWizard(immCard) {
        const { immCardTransferMoneyToCheckingAccount, validateStep, setVisibleStep } = this.props;
        const immSteps = immCardTransferMoneyToCheckingAccount.get('steps');
        const immFirstStep = immSteps.get(FIRST_STEP);
        const availableBalance = {
            amount: immCardTransferMoneyToCheckingAccount.getIn(['response', 'jimppdtesaldoDipantesyDespTrasp', 'amount']),
            currency: immCardTransferMoneyToCheckingAccount.getIn(['response', 'jimppdtesaldoDipantesyDespTrasp', 'currency'])
        };

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => { },
            finish: this.handleFinish,
            cancel: this.handleToggleCancelModal
        };

        const amount = formatAmountForService(immFirstStep.get('amount'), true);
        const currency = immFirstStep.get('currency');
        const destinationAccount = formatCardContract(immCard);
        const pan = stringHelper.nonNumericFilter(immCard.get('number'));

        const operationParams = {
            ammount: amount,
            currency,
            destinationAccount,
            pan
        };

        return (
            <Wizard
                viewMode={WIZARD_VERTICAL_VIEW_MODE}
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immCardTransferMoneyToCheckingAccount.get('visibleStep')}
                wizardClass="card-transfer-money-to-checking-account__wizard"
                onConfirmLeave={this.handleConfirmLeave}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                >
                    <CardTransferMoneyToCheckingAccountStep1
                        immCard={immCard}
                        immStep={immFirstStep}
                        availableBalance={availableBalance}
                        amountMultipleOfValue={AMOUNT_MULTIPLE_OF_NUMBER}
                        commissionPercentage={COMMISSION_PERCENTAGE}
                        minimumToTransfer={MINIMUM_TO_TRANSFER}
                        maximumToTransfer={MAXIMUM_TO_TRANSFER}
                        onAmountChange={this.handleAmountChange}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    omitPreviousButton={true}
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={false}
                    immFinalButton="cardTransferMoneyToCheckingAccount-confirm"
                >
                    <VerifyOtpStep
                        operationType={CARD_TRANSFER_MONEY_TO_CHECKING_ACCOUNT}
                        operationParams={operationParams}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildBodyContent(immCard) {
        const { immCardTransferMoneyToCheckingAccount } = this.props;
        const submitSuccessful = immCardTransferMoneyToCheckingAccount.get('submitSuccessful');
        const fetchError = immCardTransferMoneyToCheckingAccount.get('fetchError');
        const submitError = immCardTransferMoneyToCheckingAccount.get('submitError');
        const preleaveCancelModal = this.buildPreleaveCancelModal();

        if (submitSuccessful) {
            return (
                <CardTransferMoneyToCheckingAccountFeedbackSuccess />
            );
        }

        if (fetchError || submitError) {
            return (
                <CardTransferMoneyToCheckingAccountFeedbackError />
            );
        }

        const title = formatText('cardTransferMoneyToCheckingAccount-title');
        const wizard = this.buildWizard(immCard);

        return (
            <div className="row no-outside-gutter">
                <div className="card-transfer-money-to-checking-account__title">
                    <h4>{title}</h4>
                </div>
                <div className="card-transfer-money-to-checking-account__wizard-column col-xs-8">
                    <div className="card-transfer-money-to-checking-account__wizard-container">
                        {wizard}
                        {preleaveCancelModal}
                    </div>
                </div>
                <div className="card-transfer-money-to-checking-account__card-details-column col-xs-4">
                    <CustomCardDetails immCard={immCard} />
                    <ContractInfo immCard={immCard} />
                </div>
            </div>
        );
    }

    render() {
        const { match: { params: { cardId } }, immCards, immCardTransferMoneyToCheckingAccount } = this.props;
        const immCard = immCards.get('byId').get(cardId);

        if (!immCard || !immCardTransferMoneyToCheckingAccount || immCardTransferMoneyToCheckingAccount.get('isFetching')) {
            return <LoadingSection />;
        }
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.get('alias').get('current'),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardTransferMoneyToCheckingAccount-title'),
                url: ''
            }
        ];

        const bodyContent = this.buildBodyContent(immCard);

        return (
            <section className="card-transfer-money-to-checking-account">
                <OKHeaderCC
                    title="cardTransferMoneyToCheckingAccount-title"
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true}
                />
                <div className="card-transfer-money-to-checking-account__body">
                    {bodyContent}
                </div>
            </section>
        );
    }
}

CardTransferMoneyToCheckingAccountView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardTransferMoneyToCheckingAccount: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    requestCardTransferMoneyToCheckingAccount: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.constructor = CardTransferMoneyToCheckingAccountView;
module.exports.CardTransferMoneyToCheckingAccountView = connect(
    state => ({
        immCards: state.cards,
        immCardTransferMoneyToCheckingAccount: state.cardTransferMoneyToCheckingAccount,

    }),
    {
        validateStep: cardTransferMoneyToCheckingAccountActions.validateStep,
        setVisibleStep: cardTransferMoneyToCheckingAccountActions.setVisibleStep,
        resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
        handleFinish: cardTransferMoneyToCheckingAccountActions.postTransferMoneyToCheckingAccount,
        clearRequest: cardTransferMoneyToCheckingAccountActions.clearRequest,
        handleAmountChange: cardTransferMoneyToCheckingAccountActions.setAmount,
        requestCardTransferMoneyToCheckingAccount: cardTransferMoneyToCheckingAccountActions.requestCardTransferMoneyToCheckingAccount,
    }
)(withRouter(CardTransferMoneyToCheckingAccountView));
